module.exports = __webpack_public_path__ + "static/img/lbil_logo.8f2947f0.png";